import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { iHttpPaginatedResponse } from '../interfaces/iHttpPaginatedResponse';

@Injectable({
  providedIn: 'root'
})
export class SupporterService {

  constructor(
    private _http: HttpClient
  ) { }

  public getSupporters(){
    return this._http.get(environment.apiEndpoint + '/api/admin/supporters').pipe(
      map(
        res => {
          return res;
        }
      )
    );
  }

  public getSupportersPaginated(page,pp,sorts,filters): Observable<iHttpPaginatedResponse> {
    return this._http.get<iHttpPaginatedResponse>(environment.apiEndpoint + `/api/admin/supportersPaginated?page=${page}&pp=${pp}&sort=${sorts}&${filters}`).pipe(
      map((res:any) => {
        let supporters=[];
        res.data.forEach(supporter=>{
          supporters.push(supporter);
        });
        res.data = supporters;
        return res;
      })
    );
  }

  public getSupporter(supporterId:number){
    return this._http.get(environment.apiEndpoint + '/api/admin/supporter/' + supporterId).pipe(
      map(
        (res:any) => {
          return res;
        }
      )
    );
  }

  public updateSupporter(supporter:any, fileB64:string, fileType:string){
    return this._http.put(environment.apiEndpoint + '/api/admin/supporter/' + supporter.id, {supporter:supporter, fileB64:fileB64, fileType:fileType}).pipe(
      map(
        res => {
          return res;
        }
      )
    );
  }

  public addSupporter(){
    return this._http.post(environment.apiEndpoint + '/api/admin/supporter', {name: 'New supporter...'}).pipe(
      map(
        res => {
          return res;
        }
      )
    );
  }
}
